// extracted by mini-css-extract-plugin
export var modalFooter = "_sw-0";